<template>
	<div class="rewardContainer" :style="{
            backgroundImage: 'url(' + theme.images_temp + ')'
          }">
		<div class="logo">
			<img src="@/assets/image/reward/4.png" alt="">
			<p class="text1">{{theme.name | getName}}</p>
			<p class="text2">{{theme.name | getName1}}</p>
		</div>
		<div class="center">
			<img src="@/assets/image/reward/1.png" alt="">
		</div>
		<div class="mainContainer">
			<div class="main">
				<div class="reward-list">
					<p class="title">{{nowGift.name}}</p>
					<div class="swiper-container reward-container">
						<div class="swiper-wrapper">
							<template v-for="(item, index) in gift">
								<div class="swiper-slide reward-item" :key="index">
									<img :src="item.images_temp" alt="">
								</div>
							</template>
						</div>
						<div class="swiper-button-prev"></div>
						<div class="swiper-button-next"></div>
					</div>
					<div class="addNum">
						<p>中奖人数</p>
						<div>
							<p class="num">
								{{nowGift.quota}}
							</p>
						</div>
					</div>
				</div>
				<div class="reward-person">
					<div class="title">
						<img src="@/assets/image/reward/5.png" alt="">
					</div>
					<div class="swiper-container person-container">
						<div class="swiper-wrapper">
							<template v-for="(item,index) in personList">
								<div class="swiper-slide swiper-no-swiping person-item">
									<div class="img-box" :style="{
            backgroundImage: 'url(' + item.avatar_temp + ')',
            backgroundSize: 'cover',
          }">
									</div>
									<div class="info">
										<p>{{item.name}}</p>
										<p>{{item.mobile==0?'':item.mobile}}</p>
									</div>
								</div>
							</template>
						</div>
					</div>
					<div class="startBtn" @click="startReward">
						{{rewardActive==0?'开始抽奖':'停止'}}
					</div>
				</div>

			</div>
			<p class="belong py-4">优普道集团 {{theme.organizer}}</p>
		</div>
		<div class="reward-pup" v-show="showReward">
			<div class="header">
				<img class="up" src="@/assets/image/reward/10.png" alt="">
				<img class="line" src="@/assets/image/reward/9.png" alt="">
				<div class="img-box" :style="{
            backgroundImage: 'url(' + luckDog.avatar_temp + ')',
            backgroundSize: 'cover',
          }">
					<!-- <img :src="luckDog.avatar_temp" alt=""> -->
				</div>
			</div>
			<div class="content">
				<div class="info">
					<p>{{luckDog.name}}</p>
					<p>{{luckDog.mobile=='0'?'':luckDog.mobile}}</p>
				</div>
				<p class="desc">{{luckDog.desire}}</p>
				<!-- <img src="@/assets/image/reward/11.png" alt=""> -->
			</div>
			<div class="continueBtn" @click="showReward=false">
				继续抽奖
			</div>
		</div>
		<div class="music-box">
			<audio loop ref="audio" :src="theme.music_temp"></audio>
		</div>
	</div>
</template>
<script>
	import Swiper from "swiper";
	export default {
		data() {
			return {
				stop: false,
				timer: null,
				autoplay: 1,
				speed: 100,
				personSwiper: null,
				rewardActive: 0,
				showReward: false,
				personActive: -1,
				personList: [],
				gift: [],
				theme: {
					name: ''
				},
				nowGift: {
					name: '',
					quota: ''
				},
				nowPerson: -1,
				luckDog: ''
			}
		},
		filters: {
			getName(val) {
				let arr = val.split("，");
				return arr[0]
			},
			getName1(val) {
				let arr = val.split("，");
				return arr[1]
			}
		},
		methods: {
			onPlay() {},
			onPause() {},
			// 获取名单
			getLuckRoster() {
				this.$api.getLuckRoster().then(res => {
					this.personList = res.data;
					this.$nextTick(() => {
						this.initPersonSwiper();
						this.personSwiper.stopAutoplay();
					})
				})
			},
			//获取奖项
			getLuckPrizes() {
				this.$api.getLuckPrizes().then(res => {
					this.gift = res.data;
					this.nowGift = this.gift[0];
					this.$nextTick(() => {
						this.initRewardSwiper();
					})
				})
			},
			startTimerInterval() {
				clearInterval(this.timer);
				if (this.autoplay >= 3000) {
					return;
				}
				this.autoplay += 1000;
				this.personSwiper.slideNext();
				this.timer = setInterval(this.startTimerInterval(), this.autoplay);
			},
			// 获取中奖名单
			getLuckDraw() {
				this.$api.getLuckDraw({
					prize: this.nowGift.id
				}).then(res => {
					this.luckDog = res.data;
					this.personList.forEach((item, index) => {
						if (item.id == this.luckDog.id) {
							this.personActive = index;
						}
					})
				})
			},
			//开始抽奖
			startReward() {
				if (this.rewardActive == 0) {
					this.$refs.audio.play()
					this.rewardActive = 1
					// this.personSwiper.startAutoplay();

					this.getLuckDraw();
					this.timer = setInterval(() => {
						this.personSwiper.slideNext();
					}, this.autoplay)
				} else {
					clearInterval(this.timer);
					this.autoplay = 1;
					this.timer = setInterval(() => {
						if (this.personList[this.personSwiper.realIndex].id == this.luckDog.id) {
							clearInterval(this.timer);
							this.$refs.audio.pause()
							this.autoplay = 1;
							this.rewardActive = 0;
							this.showReward = true;
							return;
						} else {
							this.personSwiper.slideNext();
						}
					}, this.autoplay)


				}
			},
			setFontSize() {
				var docEl = document.documentElement;
				var clientWidth = docEl.clientWidth;
				var baseFontSize = 100;
				var designWidth = 1920;
				var currentFontSize = (clientWidth / designWidth) * baseFontSize;
				docEl.style.fontSize = currentFontSize + "px";
			},
			getLuckTheme() {
				this.$api.getLuckTheme().then(res => {
					this.theme = res.data;
				})
			},
			initRewardSwiper() {
				let _this = this;
				var newsSwiper = new Swiper(".reward-container", {
					loop: true,
					speed: 1000,
					prevButton: '.swiper-button-prev',
					nextButton: '.swiper-button-next',
					onSlideChangeEnd: function(swiper) {
						_this.nowGift = _this.gift[swiper.realIndex]
					}
				});
			},
			initPersonSwiper() {
				let _this = this;
				this.personSwiper = new Swiper('.person-container', {
					watchSlidesProgress: true,
					autoplay: _this.autoplay,
					speed: _this.speed,
					loop: true,
					centeredSlides: true,
					slidesPerView: 'auto',

					onProgress: function(swiper, progress) {
						for (var i = 0; i < swiper.slides.length; i++) {
							var slide = swiper.slides.eq(i);
							var slideProgress = swiper.slides[i].progress;
							var modify = 1;
							var translate = slideProgress * modify * 0.8 + 'rem';
							var scale = 1 - Math.abs(slideProgress) / 10;
							var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
							slide.transform('translateX(' + translate + ') scale(' + scale + ')');
							slide.css('zIndex', zIndex);
							slide.css('opacity', 1);
						}
					},
				});
			}
		},
		created() {
			this.getLuckTheme();
		},
		mounted() {
			this.getLuckRoster()
			this.setFontSize();
			this.getLuckPrizes();
		},
	};
</script>
<style lang="scss">
	@font-face {
		font-family: "HYShangWeiShouShuW";
		src: url(../../assets/font/HYShangWeiShouShuW.ttf);
		font-weight: normal;
		font-style: normal;
	}

	.rewardContainer {
		user-select: none;
		width: 100%;
		height: 100vh;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-position: center 0;
		position: relative;

		.logo {
			position: absolute;
			right: 2%;
			top: 3%;
			width: 18%;

			img {
				width: 100%;
			}

			&>p {
				position: absolute;
				font-size: 0.55rem;
				font-family: HYShangWeiShouShuW;
				color: #ffffff;
			}

			.text1 {
				top: 0;
				left: 0;
			}

			.text2 {
				right: 0;
				bottom: 0;
			}
		}

		.center {
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			@include flex-center();
			width: 50%;

			img {
				width: 100%;
			}
		}

		.mainContainer {
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 84%;

			.main {
				@include flex-center();
			}

			.reward-list {
				width: 35%;
				height: 58vh;
				background: url(../../assets/image/reward/2.png) no-repeat;
				background-size: 100% 100%;

				.title {
					padding-top: 0.5rem;
					font-size: 0.43rem;
					font-family: Adobe Heiti Std;
					font-weight: normal;
					color: #FFF6C7;
					text-align: center;
				}

				.reward-container {
					height: 60%;
				}

				/deep/.swiper-button-next,
				.swiper-container-rtl .swiper-button-prev {
					background: url(../../assets/image/reward/7.png) no-repeat;
					background-size: cover;
					width: 0.39rem;
					height: 1.3rem;
					right: 2px;
					margin-top: -0.65rem;
				}

				/deep/.swiper-button-prev,
				.swiper-container-rtl .swiper-button-next {
					background: url(../../assets/image/reward/8.png) no-repeat;
					background-size: cover;
					width: 0.39rem;
					height: 1.3rem;
					left: 2px;
					margin-top: -0.65rem;
				}

				.reward-item {
					@include flex-center(column);

					img {
						max-width: 40%;
						max-height: 60%;
					}
				}

				.addNum {
					@include flex-center();

					p {
						font-size: 0.2rem;
						font-family: Adobe Heiti Std;
						font-weight: normal;
						color: #FAE5B9;
						margin-right: 0.2rem;
					}

					&>div {
						@include flex-center();

						&>p:nth-child(1) {
							width: 0.92rem;
							height: 0.28rem;
							background: url(../../assets/image/reward/center.png) no-repeat;
							background-size: cover;
							text-align: center;

						}
					}
				}


			}

			.reward-person {
				width: 65%;
				height: 58vh;
				background: url(../../assets/image/reward/3.png) no-repeat;
				background-size: 100% 100%;

				/deep/.swiper-wrapper {
					-webkit-transition-timing-function: linear;
					/*之前是ease-out*/
					-moz-transition-timing-function: linear;
					-ms-transition-timing-function: linear;
					-o-transition-timing-function: linear;
					transition-timing-function: linear;
					margin: 0 auto;
				}

				.title {
					padding: 0.5rem 0 0.3rem;
					@include flex-center();
				}

				.swiper-container {
					width: 86%;
					height: 50%;
				}







				.person-item {
					width: 20%;
					@include flex-center(column);

					.img-box {
						width: 1.68rem;
						height: 1.68rem;
						border: 2px solid #FFE3C8;
						border-radius: 0.08rem;
						overflow: hidden;
						background-position: center center;

						img {
							width: 100%;
							min-height: 100%;
						}
					}


					.info {
						margin-top: 0.2rem;

						p {
							text-align: center;
							font-size: 0.24rem;
							font-family: Adobe Heiti Std;
							font-weight: normal;
							color: #FBE7BD;

							&:nth-child(2) {
								font-size: 0.16rem;
							}
						}

						opacity: 0;
					}

				}

				/deep/.swiper-slide-active {
					.info {
						opacity: 1;
					}
				}

				.startBtn {
					width: 1.68rem;

					height: 0.58rem;
					border-radius: 0.08rem;
					background: linear-gradient(0deg, #BB0D00 0%, #FF4040 97%);
					margin: 0 auto;
					font-size: 0.24rem;
					line-height: 0.58rem;
					text-align: center;
					font-family: Adobe Heiti Std;
					font-weight: normal;
					color: #FBE5B9;
					cursor: pointer;
				}
			}
		}

		.belong {
			text-align: center;
			font-size: 0.2rem;
			color: #FFF6C7;
		}

		.reward-pup {
			width: 100%;
			height: 100vh;
			background: rgba(0, 0, 0, 0.67);
			position: fixed;
			top: 0;
			left: 0;
			z-index: 999;
			@include flex-center(column);

			.header {
				position: relative;

				.img-box {
					width: 1.74rem;
					height: 1.74rem;
					background: #FFC540;
					border: 3px solid #FFDA75;
					border-radius: 50%;
					position: relative;
					z-index: 2;
					overflow: hidden;
					background-position: center 0;

					img {
						width: 100%;
						height: 100%;
					}
				}

				&>img {
					position: absolute;
					left: 50%;
					transform: translateX(-50%);
				}

				.line {
					width: 6.99rem;
					top: -2.3rem;
					z-index: 1;
				}

				.up {
					width: 3.86rem;
					bottom: -0.4rem;
					z-index: 3;
				}
			}

			.content {
				padding: 0.6rem 0 0.4rem;
				width: 6.48rem;
				// height: 2.8rem;
				border: 3px solid #FBE5B9;
				border-radius: 0.16rem;
				@include flex-center(column);

				background: rgba(0, 0, 0, .6);

				.info {
					width: 100%;

					p {
						font-size: 0.24rem;
						font-family: Source Han Sans CN;
						font-weight: 500;
						color: #FFF6C3;
						background: linear-gradient(180deg, #FFFFD2 3.8818359375%, #DCC7A7 100%);
						-webkit-background-clip: text;
						-webkit-text-fill-color: transparent;
						text-align: center;
						margin-top: 0.1rem;
					}
				}

				&>img {
					margin-top: 0.3rem;
					width: 5.12rem;
				}

				.desc {
					padding: 0 0.2rem;
					margin-top: 0.3rem;
					font-size: .4rem;
					font-family: zihun181hao-feichibiaotiti;
					font-weight: 400;
					color: #FFF6C3;
					line-height: 0.48rem;
					text-align: justify;
					background: linear-gradient(180deg, #FFFFD2 3.8818359375%, #DCC7A7 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}

			.continueBtn {
				margin-top: 0.5rem;
				width: 1.71rem;
				height: 0.58rem;
				background: linear-gradient(0deg, #BB0D00 0%, #FF4040 97%);
				border-radius: 0.16rem;
				font-size: 0.24rem;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #FBE5B9;
				text-align: center;
				line-height: 0.58rem;
				cursor: pointer;
			}
		}
	}
</style>
